module.exports = __webpack_public_path__ + "static/media/clarity_ici_demo.afc0b32b.mp4";